var _polygon, _polygon2, _polygon3, _polygon4, _polygon5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "72 108 81 108 81 72 99 72 72 36 45 72 63 72 63 108 72 108"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 0 63 18 63 18 18 63 18 63 0 0 0"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "144 0 81 0 81 18 126 18 126 63 144 63 144 0"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "144 144 144 81 126 81 126 126 81 126 81 144 144 144"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "0 144 63 144 63 126 18 126 18 81 0 81 0 144"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnUp);
export default __webpack_public_path__ + "static/media/btn_up.a8184135fbd614c32b8f4dc6155bd92d.svg";
export { ForwardRef as ReactComponent };